import React from 'react'
import { safeLocalFormat } from '../../../utilities/functions';

const RequestDate = ({row}) => {
  return <div>{row.requestDate ? safeLocalFormat(row.requestDate) : ""}</div>;
}

export default RequestDate
